const mutations = {
  userData (state, payload) {
    state.userData = payload
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js